module.exports = __webpack_public_path__ + "static/media/splashIcon_3x.4f29e526.png";